<template>
    <transition name="show">
        <div class="choosePet" v-show="show">
            <v-header :no-show='true' v-on:listen-head-show='listenHeadShow' :mine='true'></v-header>
            <div class="title">{{$t('choosePet.mycute')}}</div>
            <div class="content" ref='wrapper'>
                <div style="height:600px;">
                    <div class="sign">{{$t('choosePet.choicecute')}}</div>
                    <div class="petBox">
                        <ul>
                            <li class="item" v-for="(petItem,index) in petsInfo" :key="index" @click="deviceBindPet(petItem)">
                                <div class="itemImg">
                                    <img :src="petItem.portrait" alt="">
                                </div>
                                <div class="itemName">{{petItem.name}}</div>
                            </li>

                        </ul>
                        <div v-if="this.petsInfoLen==5?false:addBtn" class="item" @click="addmyPet">
                            <div class="itemImg">
                                <img src="../image/addmypet.png" alt="">
                            </div>
                            <div class="itemName">{{$t('addpet.addpet')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import header from "./header";
import Qs from "qs";
import { getpet } from "../ClientServerApi/index.js";
import { bindPet } from "../deviceApi/index.js";
import { unbindPet } from "../ClientServerApi/index.js";
export default {
    inject: ["reload"],
    name: "choosePet",
    props: ["isShow", "deviceCode", "choose", "addBtn"],
    data() {
        return {
            show: false,
            petsInfo: [],
            petsInfoLen: ""
        };
    },
    created() {
    
        this.getPetList();
        
    },
    beforeUpdate() {
        this.$nextTick(() => {
            this.Scroll = new IScroll(this.$refs.wrapper, {
                click: true
            });
        });
    },
    methods: {
        listenHeadShow(data) {
            //向父组件传递关闭面板信息
            this.show = data;
            this.$emit("listen-isShow", false);
        },
        getPetList() {
            //页面加载宠物列表
            getpet()
            .then(res => {
                // console.log(res)
                this.petsInfo = res.data.data;
                this.petsInfoLen = res.data.data.length;
            })
            .catch(err => {});
        },
        deviceBindPet(data) {
            if (this.choose == "") {
                this.show = false;
                this.$emit("listen-isShow", false);
                this.$emit("pet", data);
            } else {
                let params = Qs.stringify({ deviceCode: this.deviceCode });
                unbindPet(params)
                    .then(res => {
                        // console.log("解绑res:",this.petsInfo);
                        if (res.data.header.status == 81003) {
                            this.$message({
                                message: this.$t("prompt.finding"),
                                type: "warning"
                            });
                        } else if (res.data.header.status == 1000) {
                            let params = Qs.stringify({
                                deviceCode: this.deviceCode,
                                petId: data.id
                            });
                            // console.log(data.id);
                            bindPet(params)
                                .then(res => {
                                    // console.log("res:",res);
                                    if (res.data.header.status == 81003) {
                                        this.show = false;
                                        this.$emit("listen-isShow", false);
                                        this.$message(
                                            this.$t("prompt.choosePetone")
                                        );
                                        // alert("宠物正在协寻中不可以绑定");
                                    } else if (res.data.header.status == 1000) {
                                        this.show = false;
                                        this.$emit("listen-isShow", false);
                                        this.reload();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.$message(
                                        this.$t("prompt.choosePettwo")
                                    );
                                    // alert("选择宠物失败");
                                });
                        } else if (res.data.header.status == 80002) {
                            this.$message.error(this.$t("prompt.nodevice"));
                        }else {
                            //包括80024 device not bind pet；
                          console.log(res.data.header.message)
                         let params = Qs.stringify({
                                deviceCode: this.deviceCode,
                                petId: data.id
                            });
                            // console.log(data.id);
                            bindPet(params)
                                .then(res => {
                                    // console.log("res:",res);
                                    if (res.data.header.status == 81003) {
                                        this.show = false;
                                        this.$emit("listen-isShow", false);
                                        this.$message(
                                            this.$t("prompt.choosePetone")
                                        );
                                        // alert("宠物正在协寻中不可以绑定");
                                    } else if (res.data.header.status == 1000) {
                                        this.show = false;
                                        this.$emit("listen-isShow", false);
                                        this.reload();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.$message(
                                        this.$t("prompt.choosePettwo")
                                    );
                                    // alert("选择宠物失败");
                                });
                        }
                    })
                    .catch(error => {});
            }
        },
        addmyPet() {
            // this.$router.push("/addpet");
            this.$router.push({name: 'addpet', params: {fromPage:'home'}})

        }
    },
    watch: {
        //监听porps：isShow的变化状态后改变中间变量show的值,这里不能直接改变porps的，只能用中间变量来过渡
        isShow() {
            this.show = this.isShow;
        }
    },
    components: {
        "v-header": header
    }
};
</script>

<style scoped>
.choosePet {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0px;
    width: 100%;
    z-index: 30;
    background-color: #fff;
    transition: all 0.2s linear;
}
.choosePet.show-enter,
.choosePet.show-leave-to {
    transform: translateX(100%);
}

.choosePet .title {
    color: #828282;
    text-align: center;
    font-size: 0.85rem;
    margin-top: 1rem;
}
.content {
    padding: 0 10px;
    position: absolute;
    top: 65px;
    bottom: 0;
    width: 95%;
    overflow: hidden;
    touch-action: none;
}
.content .sign {
    color: #808080;
    text-align: center;
    font-size: 0.85rem;
    margin-top: 30px;
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
}
.content .petBox .item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 10px 0;
    border-bottom: 1px solid #e6e6e6;
}
.itemImg {
    flex: 6;
}
.itemImg img {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
}
.itemName {
    flex: 18;
    line-height: 4rem;
    font-size: 0.85rem;
    padding-left: 20px;
    color: #808080;
}
</style>


// WEBPACK FOOTER //
// src/components/choosePet.vue